import React, { Component } from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const {
  fundTypeNames,
  fundStrategyNames,
  cities
} = require('buyside/util/constantsFromRails.json');

import styles from './CompanyDetailsFormSectionStyles.scss';

class CompanyDetailsFormSection extends Component {
  render() {
    const { isMobile, employer } = this.props;
    const { name, aumRange, aumRangePresent, fundType, strategy, city } = employer;
    const companyDetails = [
      {
        label: 'Firm Type',
        data: fundType,
        options: fundTypeNames,
        name: 'employerDetails.fundType'
      },
      {
        label: 'Strategy',
        data: strategy,
        options: fundStrategyNames,
        name: 'employerDetails.strategy'
      },
      {
        label: 'City/Town',
        data: city,
        options: cities.map(({ name }) => name),
        name: 'employerDetails.city'
      }
    ];

    return (
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={styles.label}>Company Name</div>
          <div className={styles.data}>{name}</div>
        </div>

        <div className={`${styles.section} ${isMobile ? '' : styles.responsiveContainer}`}>
          <div className={styles.label}>AUM</div>
          {(aumRangePresent && <div className={styles.data}>{aumRange}</div>) || (
            <Field
              component={InputField}
              name="employerDetails.aum"
              addon="million (USD)"
              type="number"
              note="Your exact AUM will not be publicly visible. It will be expressed as an approximate range."
            />
          )}
        </div>

        {companyDetails.map(({ label, data, options, name }) => (
          <div
            key={label}
            className={`${styles.section} ${isMobile ? '' : styles.responsiveContainer}`}
          >
            <div className={styles.label}>{label}</div>
            {(data && <div className={styles.data}>{data}</div>) || (
              <Field component={InputField} name={name} type="select" options={options} />
            )}
          </div>
        ))}

        <div className={`${isMobile ? '' : styles.responsiveContainer}`}>
          <div className={styles.label}>Company Description</div>
          <Field component={InputField} name="employerDetails.description" type="textarea" />
          <div className={styles.descriptionWarning}>
            <strong>Note: </strong>Employers must remain anonymous in the Job Vault. Please do not
            include your company name in the description details
          </div>
        </div>
      </div>
    );
  }
}

export default CompanyDetailsFormSection;
